import React from 'react';
import { RadioButton, FlatButton } from 'material-ui';
import R from 'ramda';
import StandardWizard from './standard-offer-wizard';
import StayPayWizard from './staypay-offer-wizard';
import moment from 'moment';
const propTypes = {
  data: React.PropTypes.object,
  offersOrExtras: React.PropTypes.object,
  productType: React.PropTypes.string,
  onTextFieldChangeWithKeyPath: React.PropTypes.func,
  onRequestClose: React.PropTypes.func,
  contractingPeriod: React.PropTypes.object,
};
const SpecialOffersContainer = props => {
  const { data, offersOrExtras, productType, onTextFieldChangeWithKeyPath, contractingPeriod } = props;
  const isStayPay = R.prop('isStayPay', data);
  const isAccom = R.equals('Accommodation', productType);
  const stayPayQ = (
    <div style={{ padding: '32px 0 0 32px' }}>
      Will you be adding a Stay Pay offer?
      <RadioButton
        label="Yes"
        checked={R.has('isStayPay', data) && R.prop('isStayPay', data)}
        onCheck={() => {
          onTextFieldChangeWithKeyPath({ keyPath: ['data'], value: { isStayPay: true, offerName: 'Stay Pay', title: 'ADD STAY PAY Offer', daysOfWeek: [], stayPays: [{}] } });
        }}
      />
      <RadioButton
        label="No"
        checked={R.has('isStayPay', data) && !R.prop('isStayPay', data)}
        onCheck={() => onTextFieldChangeWithKeyPath({ keyPath: ['data', 'isStayPay'], value: false })}
      />
    </div>
  );
  if (!R.has('isStayPay', data) && isAccom) return stayPayQ;
  const sharedProps = {
    ...props,
    addAnotherNewOffer: dataToSave => {
      if (dataToSave.ratePackages && dataToSave.ratePackages.length) {
        onTextFieldChangeWithKeyPath({
          keyPath: [],
          value: {
            offersOrExtras: {
              ...offersOrExtras,
              list: [...offersOrExtras.list, dataToSave],
              selectedId: dataToSave._id,
              createNew: true,
            },
            data: {
              title: data.title,
              offerName: '',
              offerDetail: '',
              specialConditions: '',
              allowCombination: false,
              validDatesOfSale: [{
                fromDate: moment(new Date()).isAfter(contractingPeriod.endDate)
                  ? contractingPeriod.startDate : moment.utc().startOf('day').toISOString(),
                toDate: contractingPeriod.endDate,
              }],
              validDatesOfTravel: [{}],
              ratePackages: offersOrExtras.productsArray.map(o => o._id),
            },
          },
        });
        props.clearAddRateSetWizard();
        props.goToStep({ stepperWizardName: 'specialOffersStepper', componentIndex: 0 });
      } else {
        window.alert(`Please select at least one ${isAccom ? 'room' : 'product'} this offer should apply to.`);
      }
    },
  };
  if (!isStayPay || !isAccom) {
    return (<StandardWizard {...sharedProps} />);
  }
  return <StayPayWizard {...sharedProps} />;
};
SpecialOffersContainer.propTypes = propTypes;
export default SpecialOffersContainer;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/special-offers-wizard.jsx